let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5nw5x")).then(() => parcelRequire('jCgZH'));